import axios from 'axios';
import requestApi from '../../../apirest';
import { apiURL } from '../../../apirest/getAPIURL';

export async function listReviews() {
  const response = await requestApi('/review', {}, 'get');
  return response.data.reviews || [];
}

export async function listProductsForReviews() {
  const response = await requestApi('/products', {}, 'get');
  return response.data.doc || [];
}

export async function updateReview(review) {
  const response = await requestApi(
    '/review',
    {
      review: {
        id: review._id,
        name: review.name,
        message: review.message,
        rating: review.rating,
        product: review.product?._id || review.product,
        isDeleted: review.isDeleted,
      },
    },
    'patch'
  );
  return response.data;
}

// DELETE /review espera idReview como query param — o helper genérico
// requestApi manda tudo no body, por isso usa axios direto aqui (mesmo
// padrão do couponService.deleteCoupon).
export async function deleteReview(idReview) {
  const response = await axios.delete(`${apiURL}/review`, {
    params: { idReview },
    headers: { 'Cache-Control': 'no-cache', 'Content-Type': 'application/json' },
  });
  return response.data;
}
